module.exports = "<simple-notifications [options]=\"notifyOptions\"></simple-notifications>\r\n{{metricvalue}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/metric/metric.component.html
// module id = ./src/app/shared/components/widgets/metric/metric.component.html
// module chunks = main